import { render } from "./InformationHeader.vue?vue&type=template&id=00fb81c0&scoped=true&ts=true"
import script from "./InformationHeader.vue?vue&type=script&lang=ts"
export * from "./InformationHeader.vue?vue&type=script&lang=ts"

import "./InformationHeader.vue?vue&type=style&index=0&id=00fb81c0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fb81c0"]])

export default __exports__